import React, { useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import HTMLRenderer from 'react-html-renderer';

import ZoomableImage from '../ZoomableImage/ZoomableImage';
import styles from './Wysiwyg.module.scss';

const cx = classNames.bind(styles);

const Wysiwyg = ({ text, className }) => {
  useEffect(() => {
    const wrap = (el, wrapper) => {
      if (
        el &&
        !Array.from(el.parentNode.classList).includes(cx('table-wrapper'))
      ) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
      }
    };
    const wysiwygs = document.getElementsByClassName('js-wysiwyg');

    Array.from(wysiwygs).forEach((item) => {
      Array.from(item.getElementsByTagName('table')).forEach((table) => {
        let wrapper = document.createElement('div');
        wrapper.classList.add(cx('table-wrapper'));
        wrap(table, wrapper);
      });
    });
  }, []);

  return (
    <div className={cx('wysiwyg', 'js-wysiwyg', className)}>
      <HTMLRenderer
        html={text}
        components={{
          img: ZoomableImage,
        }}
      />
    </div>
  );
};

Wysiwyg.propTypes = {
  text: string.isRequired,
  className: string,
};

Wysiwyg.defaultProps = {
  className: null,
};

export default Wysiwyg;



// WEBPACK FOOTER //
// ./src/components/Wysiwyg/Wysiwyg.js